import type { MouseEvent } from "react";

// The keys that make a click the browser's: a modified click on a link
// opens a new tab or window, and the app must not route it itself.
const MODIFIER_KEYS = ["metaKey", "ctrlKey", "shiftKey", "altKey"] as const;

/** A plain left click, the one kind the app routes in-app. */
export function isPlainClick(e: MouseEvent): boolean {
  return e.button === 0 && !MODIFIER_KEYS.some((key) => e[key]);
}
